module.exports = __webpack_public_path__ + "img/yiliao.2efe8cff.png";